// Visual-only pump display convention; do not change math or stored values.
export const formatPumpProgramming = (value) => {
	if (value === null || value === undefined) return "";

	const numericValue =
		typeof value === "string"
			? parseFloat(value.replace(",", "."))
			: Number(value);

	if (!Number.isFinite(numericValue)) return "";

	const normalizedValue = Math.round(numericValue * 1000) / 1000;
	const nearestInteger = Math.round(normalizedValue);

	if (Math.abs(normalizedValue - nearestInteger) < 1e-9) {
		return String(nearestInteger);
	}
	return normalizedValue.toString();
};
